module.exports = __webpack_public_path__ + "assets/2db55eefa24b581132a889fc35fec779.png";